var items = {
  "block.minecraft.air": "aria",
  "block.minecraft.stone": "preja",
  "block.minecraft.granite": "miaroeul",
  "block.minecraft.polished_granite": "miaroeul soliad",
  "block.minecraft.diorite": "serizz",
  "block.minecraft.polished_diorite": "serizz soliad",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "andesit soliada",
  "block.minecraft.grass_block": "erba",
  "block.minecraft.dirt": "terra",
  "block.minecraft.coarse_dirt": "terra strasida",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "neceli cremes",
  "block.minecraft.warped_nylium": "neceli desformad",
  "block.minecraft.cobblestone": "rizzoeui",
  "block.minecraft.oak_planks": "ass de cerr",
  "block.minecraft.spruce_planks": "ass de abiezz",
  "block.minecraft.birch_planks": "ass de biolla",
  "block.minecraft.jungle_planks": "ass de la sgiungla",
  "block.minecraft.acacia_planks": "ass de rubinia",
  "block.minecraft.dark_oak_planks": "ass de rogora",
  "block.minecraft.crimson_planks": "ass cremese",
  "block.minecraft.warped_planks": "ass desformade",
  "block.minecraft.oak_sapling": "but de cerr",
  "block.minecraft.spruce_sapling": "but de abiezz",
  "block.minecraft.birch_sapling": "but de biolla",
  "block.minecraft.jungle_sapling": "but de la sgiungla",
  "block.minecraft.acacia_sapling": "but de rubinia",
  "block.minecraft.dark_oak_sapling": "but de rogora",
  "block.minecraft.bedrock": "preja bas",
  "block.minecraft.sand": "sabia",
  "block.minecraft.red_sand": "sabia rossa",
  "block.minecraft.gravel": "gera",
  "block.minecraft.gold_ore": "mineral d'or",
  "block.minecraft.iron_ore": "mineral de ferr",
  "block.minecraft.coal_ore": "mineral de carbon",
  "block.minecraft.nether_gold_ore": "mineral d'or del nether",
  "block.minecraft.oak_log": "bora de cerr",
  "block.minecraft.spruce_log": "bora de abiezz",
  "block.minecraft.birch_log": "bora de biolla",
  "block.minecraft.jungle_log": "bora de la giungla",
  "block.minecraft.acacia_log": "bora de rubinia",
  "block.minecraft.dark_oak_log": "bora de rogora",
  "block.minecraft.crimson_stem": "gamba cremesa",
  "block.minecraft.warped_stem": "gamba desformada",
  "block.minecraft.stripped_oak_log": "bora de cerr scarpada",
  "block.minecraft.stripped_spruce_log": "bora de abiezz scarpada",
  "block.minecraft.stripped_birch_log": "bora de biolla scarpada",
  "block.minecraft.stripped_jungle_log": "bora de la giungla scarpada",
  "block.minecraft.stripped_acacia_log": "bora de rubinia scarpada",
  "block.minecraft.stripped_dark_oak_log": "bora de rogora scarpada",
  "block.minecraft.stripped_crimson_stem": "gamba cremesa scarpada",
  "block.minecraft.stripped_warped_stem": "gamba desformada scarpada",
  "block.minecraft.stripped_oak_wood": "legn de cerr scarpad",
  "block.minecraft.stripped_spruce_wood": "legn de abiezz scarpad",
  "block.minecraft.stripped_birch_wood": "legn de biolla scarpad",
  "block.minecraft.stripped_jungle_wood": "legn de la giungla scarpad",
  "block.minecraft.stripped_acacia_wood": "legn de rubinia scarpad",
  "block.minecraft.stripped_dark_oak_wood": "legn de rogora scarpad",
  "block.minecraft.stripped_crimson_hyphae": "ife cremese scarpade",
  "block.minecraft.stripped_warped_hyphae": "ife desformade scarpade",
  "block.minecraft.oak_wood": "legn de cerr",
  "block.minecraft.spruce_wood": "legn de abiezz",
  "block.minecraft.birch_wood": "legn de biolla",
  "block.minecraft.jungle_wood": "legn de la giungla",
  "block.minecraft.acacia_wood": "legn de rubinia",
  "block.minecraft.dark_oak_wood": "legn de rogora",
  "block.minecraft.crimson_hyphae": "ife cremese",
  "block.minecraft.warped_hyphae": "ife desformade",
  "block.minecraft.oak_leaves": "foeuje de cerr",
  "block.minecraft.spruce_leaves": "foeuje de abiezz",
  "block.minecraft.birch_leaves": "foeuje de biolla",
  "block.minecraft.jungle_leaves": "foeuje de la sgiungla",
  "block.minecraft.acacia_leaves": "foeuje de rubinia",
  "block.minecraft.dark_oak_leaves": "foeuje de rogora",
  "block.minecraft.sponge": "sponga",
  "block.minecraft.wet_sponge": "sponga masarada",
  "block.minecraft.glass": "veder",
  "block.minecraft.lapis_ore": "mineral de lapislazzer",
  "block.minecraft.lapis_block": "bloch de lapislazzer",
  "block.minecraft.dispenser": "scompartidor",
  "block.minecraft.sandstone": "molera",
  "block.minecraft.chiseled_sandstone": "molera sigillada",
  "block.minecraft.cut_sandstone": "molera tajada",
  "block.minecraft.note_block": "bloch sonador",
  "block.minecraft.powered_rail": "binari motorizad",
  "block.minecraft.detector_rail": "binari relevador",
  "block.minecraft.sticky_piston": "piston impatachent",
  "block.minecraft.cobweb": "ragnera",
  "block.minecraft.grass": "erba",
  "block.minecraft.fern": "files",
  "block.minecraft.dead_bush": "pianta seca",
  "block.minecraft.seagrass": "erba del mar",
  "block.minecraft.sea_pickle": "cocumer del mar",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "lana bianca",
  "block.minecraft.orange_wool": "lana naranza",
  "block.minecraft.magenta_wool": "lana magenta",
  "block.minecraft.light_blue_wool": "lana bloeu ciar",
  "block.minecraft.yellow_wool": "lana sgialda",
  "block.minecraft.lime_wool": "lana lime",
  "block.minecraft.pink_wool": "lana roeusa",
  "block.minecraft.gray_wool": "lana grisa",
  "block.minecraft.light_gray_wool": "lana grisa ciar",
  "block.minecraft.cyan_wool": "lana celesta",
  "block.minecraft.purple_wool": "lana vioeula",
  "block.minecraft.blue_wool": "lana bloeu",
  "block.minecraft.brown_wool": "lana marrona",
  "block.minecraft.green_wool": "lana verda",
  "block.minecraft.red_wool": "lana rossa",
  "block.minecraft.black_wool": "lana negra",
  "block.minecraft.dandelion": "bofanella",
  "block.minecraft.poppy": "popolana",
  "block.minecraft.blue_orchid": "orchidea bloeu",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia",
  "block.minecraft.red_tulip": "tolipan ross",
  "block.minecraft.orange_tulip": "tolipan naranz",
  "block.minecraft.white_tulip": "tolipan bianch",
  "block.minecraft.pink_tulip": "tolipan roeusa",
  "block.minecraft.oxeye_daisy": "margherita",
  "block.minecraft.cornflower": "lori",
  "block.minecraft.lily_of_the_valley": "moneghin",
  "block.minecraft.wither_rose": "roeusa del wither",
  "block.minecraft.brown_mushroom": "fonsg marron",
  "block.minecraft.red_mushroom": "fonsg ross",
  "block.minecraft.crimson_fungus": "fonsg cremes",
  "block.minecraft.warped_fungus": "fonsg desformad",
  "block.minecraft.crimson_roots": "radis cremes",
  "block.minecraft.warped_roots": "radis desformade",
  "block.minecraft.nether_sprouts": "but del nether",
  "block.minecraft.weeping_vines": "ergna caragnenta",
  "block.minecraft.twisting_vines": "ergna intortia",
  "block.minecraft.sugar_cane": "canna de zucher",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bamboo",
  "block.minecraft.gold_block": "bloch d'or",
  "block.minecraft.iron_block": "bloch de ferr",
  "block.minecraft.oak_slab": "pioda de cerr",
  "block.minecraft.spruce_slab": "pioda de abiezz",
  "block.minecraft.birch_slab": "pioda de biolla",
  "block.minecraft.jungle_slab": "pioda de la sgiungla",
  "block.minecraft.acacia_slab": "pioda de rubinia",
  "block.minecraft.dark_oak_slab": "pioda de rogora",
  "block.minecraft.crimson_slab": "pioda cremesa",
  "block.minecraft.warped_slab": "pioda desformada",
  "block.minecraft.stone_slab": "pioda de preja",
  "block.minecraft.smooth_stone_slab": "pioda de preja lissa",
  "block.minecraft.sandstone_slab": "pioda de molera",
  "block.minecraft.cut_sandstone_slab": "pioda de molera tajada",
  "block.minecraft.petrified_oak_slab": "pioda de cerr de preja",
  "block.minecraft.cobblestone_slab": "pioda de rizzoeui",
  "block.minecraft.brick_slab": "pioda de quadrei",
  "block.minecraft.stone_brick_slab": "pioda de quadrei de preja",
  "block.minecraft.nether_brick_slab": "pioda de quadrei del nether",
  "block.minecraft.quartz_slab": "pioda de quarz",
  "block.minecraft.red_sandstone_slab": "pioda de molera rossa",
  "block.minecraft.cut_red_sandstone_slab": "pioda de molera rossa tajada",
  "block.minecraft.purpur_slab": "pioda de purpur",
  "block.minecraft.prismarine_slab": "pioda de prismarina",
  "block.minecraft.prismarine_brick_slab": "pioda de quadrei de prismarina",
  "block.minecraft.dark_prismarine_slab": "pioda de prismarina scura",
  "block.minecraft.smooth_quartz": "bloch de quarz liss",
  "block.minecraft.smooth_red_sandstone": "molera rossa lissa",
  "block.minecraft.smooth_sandstone": "molera lissa",
  "block.minecraft.smooth_stone": "preja lissa",
  "block.minecraft.bricks": "quadrei",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "libreria",
  "block.minecraft.mossy_cobblestone": "bloch de rizzoeui tepos",
  "block.minecraft.obsidian": "ossidiana",
  "block.minecraft.torch": "torcia",
  "block.minecraft.end_rod": "barra de l'end",
  "block.minecraft.chorus_plant": "pianta de chorus",
  "block.minecraft.chorus_flower": "fior de chorus",
  "block.minecraft.purpur_block": "bloch de purpur",
  "block.minecraft.purpur_pillar": "pilaster de purpur",
  "block.minecraft.purpur_stairs": "basei de purpur",
  "block.minecraft.spawner": "generador",
  "block.minecraft.oak_stairs": "basei de cerr",
  "block.minecraft.chest": "cesta",
  "block.minecraft.diamond_ore": "mineral de diamant",
  "block.minecraft.diamond_block": "bloch de diamant",
  "block.minecraft.crafting_table": "banch de lavorà",
  "block.minecraft.farmland": "terra de somenà",
  "block.minecraft.furnace": "fornas",
  "block.minecraft.ladder": "scala",
  "block.minecraft.rail": "binari",
  "block.minecraft.cobblestone_stairs": "basei de rizzoeui",
  "block.minecraft.lever": "leva",
  "block.minecraft.stone_pressure_plate": "pian a pression de preja",
  "block.minecraft.oak_pressure_plate": "pian a pression de cerr",
  "block.minecraft.spruce_pressure_plate": "pian a pression de abiezz",
  "block.minecraft.birch_pressure_plate": "pian a pression de biolla",
  "block.minecraft.jungle_pressure_plate": "pian a pression de la sgiungla",
  "block.minecraft.acacia_pressure_plate": "pian a pression de rubinia",
  "block.minecraft.dark_oak_pressure_plate": "pian a pression de rogora",
  "block.minecraft.crimson_pressure_plate": "pian a pression cremes",
  "block.minecraft.warped_pressure_plate": "pian a pression desformad",
  "block.minecraft.polished_blackstone_pressure_plate": "pian a pression de prejanegra soliada",
  "block.minecraft.redstone_ore": "mineral de prejarossa",
  "block.minecraft.redstone_torch": "torcia de prejarossa",
  "block.minecraft.snow": "fioca",
  "block.minecraft.ice": "giazz",
  "block.minecraft.snow_block": "bloch de fioca",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "terra creja",
  "block.minecraft.jukebox": "sgira-disch",
  "block.minecraft.oak_fence": "stongarda de cerr",
  "block.minecraft.spruce_fence": "stongarda de abiezz",
  "block.minecraft.birch_fence": "stongarda de biolla",
  "block.minecraft.jungle_fence": "stongarda de la sgiungla",
  "block.minecraft.acacia_fence": "stongarda de rubinia",
  "block.minecraft.dark_oak_fence": "stongarda de rogora",
  "block.minecraft.crimson_fence": "stongarda cremes",
  "block.minecraft.warped_fence": "stongarda desformada",
  "block.minecraft.pumpkin": "zuca",
  "block.minecraft.carved_pumpkin": "zuca sigillada",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sabia di anime",
  "block.minecraft.soul_soil": "terra di anime",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt soliad",
  "block.minecraft.soul_torch": "torcia di anime",
  "block.minecraft.glowstone": "preja lusenta",
  "block.minecraft.jack_o_lantern": "lanterna de zuca",
  "block.minecraft.oak_trapdoor": "bussera de cerr",
  "block.minecraft.spruce_trapdoor": "bussera de abiezz",
  "block.minecraft.birch_trapdoor": "bussera de biolla",
  "block.minecraft.jungle_trapdoor": "bussera de la sgiungla",
  "block.minecraft.acacia_trapdoor": "bussera de rubinia",
  "block.minecraft.dark_oak_trapdoor": "bussera de rogora",
  "block.minecraft.crimson_trapdoor": "bussera cremesa",
  "block.minecraft.warped_trapdoor": "bussera desformada",
  "block.minecraft.infested_stone": "preja infestada",
  "block.minecraft.infested_cobblestone": "rizzoeui infestad",
  "block.minecraft.infested_stone_bricks": "quadrei de preja infestad",
  "block.minecraft.infested_mossy_stone_bricks": "quadrei de preja tepos infestad",
  "block.minecraft.infested_cracked_stone_bricks": "quadrei de preja crep infestad",
  "block.minecraft.infested_chiseled_stone_bricks": "quadrei de preja sigillad infestad",
  "block.minecraft.stone_bricks": "quadrei de preja",
  "block.minecraft.mossy_stone_bricks": "quadrei de preja tepos",
  "block.minecraft.cracked_stone_bricks": "quadrei de preja crep",
  "block.minecraft.chiseled_stone_bricks": "quadrei de preja sigillad",
  "block.minecraft.brown_mushroom_block": "bloch de fonsg marron",
  "block.minecraft.red_mushroom_block": "bloch de fonsg ross",
  "block.minecraft.mushroom_stem": "picol de fonsg",
  "block.minecraft.iron_bars": "sbarre de ferr",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panell de veder",
  "block.minecraft.melon": "inguria",
  "block.minecraft.vine": "ergna",
  "block.minecraft.oak_fence_gate": "restell de cerr",
  "block.minecraft.spruce_fence_gate": "restell de abiezz",
  "block.minecraft.birch_fence_gate": "restell de biolla",
  "block.minecraft.jungle_fence_gate": "restell de la sgiungla",
  "block.minecraft.acacia_fence_gate": "restell de rubinia",
  "block.minecraft.dark_oak_fence_gate": "restell de rogora",
  "block.minecraft.crimson_fence_gate": "restell cremes",
  "block.minecraft.warped_fence_gate": "restell desformad",
  "block.minecraft.brick_stairs": "basei de quadrei",
  "block.minecraft.stone_brick_stairs": "basei de quadrei de preja",
  "block.minecraft.mycelium": "miceli",
  "block.minecraft.lily_pad": "lavedon",
  "block.minecraft.nether_bricks": "quadrei del nether",
  "block.minecraft.cracked_nether_bricks": "quadrei del nether crep",
  "block.minecraft.chiseled_nether_bricks": "quadrei del nether sigillad",
  "block.minecraft.nether_brick_fence": "stongarda de quadrei del nether",
  "block.minecraft.nether_brick_stairs": "basei de quadrei del nether",
  "block.minecraft.enchanting_table": "banch de instriament",
  "block.minecraft.end_portal_frame": "telar del portal de l'end",
  "block.minecraft.end_stone": "preja de l'end",
  "block.minecraft.end_stone_bricks": "quadrei de preja de l'end",
  "block.minecraft.dragon_egg": "oeuv de dragon",
  "block.minecraft.redstone_lamp": "lampeda de prejarossa",
  "block.minecraft.sandstone_stairs": "basei de molera",
  "block.minecraft.emerald_ore": "mineral de smerald",
  "block.minecraft.ender_chest": "cesta de l'end",
  "block.minecraft.tripwire_hook": "rampin de fil trapola",
  "block.minecraft.emerald_block": "bloch de smerald",
  "block.minecraft.spruce_stairs": "basei de abiezz",
  "block.minecraft.birch_stairs": "basei de biolla",
  "block.minecraft.jungle_stairs": "basei de la sgiungla",
  "block.minecraft.crimson_stairs": "basei cremes",
  "block.minecraft.warped_stairs": "basei desformad",
  "block.minecraft.command_block": "bloch di comand",
  "block.minecraft.beacon": "far",
  "block.minecraft.cobblestone_wall": "mur de rizzoeui",
  "block.minecraft.mossy_cobblestone_wall": "mur de rizzoeui tepos",
  "block.minecraft.brick_wall": "mur de quadrei",
  "block.minecraft.prismarine_wall": "mur de prismarina",
  "block.minecraft.red_sandstone_wall": "mur de molera rossa",
  "block.minecraft.mossy_stone_brick_wall": "mur de quadrei de preja tepos",
  "block.minecraft.granite_wall": "mur de miaroeul",
  "block.minecraft.stone_brick_wall": "mur de quadrei de preja",
  "block.minecraft.nether_brick_wall": "mur de quadrei del nether",
  "block.minecraft.andesite_wall": "mur de andesit",
  "block.minecraft.red_nether_brick_wall": "mur de quadrei ross del nether",
  "block.minecraft.sandstone_wall": "mur de molera",
  "block.minecraft.end_stone_brick_wall": "mur de quadrei de preja de l'end",
  "block.minecraft.diorite_wall": "mur de serizz",
  "block.minecraft.blackstone_wall": "mur de prejanegra",
  "block.minecraft.polished_blackstone_wall": "mur de prejanegra soliada",
  "block.minecraft.polished_blackstone_brick_wall": "mur de quadrei de prejanegra soliada",
  "block.minecraft.stone_button": "boton de preja",
  "block.minecraft.oak_button": "boton de cerr",
  "block.minecraft.spruce_button": "boton de abiezz",
  "block.minecraft.birch_button": "boton de biolla",
  "block.minecraft.jungle_button": "boton de la sgiungla",
  "block.minecraft.acacia_button": "boton de rubinia",
  "block.minecraft.dark_oak_button": "boton de rogora",
  "block.minecraft.crimson_button": "boton cremes",
  "block.minecraft.warped_button": "boton desformad",
  "block.minecraft.polished_blackstone_button": "boton de prejanegra soliada",
  "block.minecraft.anvil": "incusgen",
  "block.minecraft.chipped_anvil": "incusgen sfrisada",
  "block.minecraft.damaged_anvil": "incusgen strapellada",
  "block.minecraft.trapped_chest": "cesta-trapola",
  "block.minecraft.light_weighted_pressure_plate": "pian a pression per pes piscinin",
  "block.minecraft.heavy_weighted_pressure_plate": "pian a pression per pes grand",
  "block.minecraft.daylight_detector": "rilevador del sol",
  "block.minecraft.redstone_block": "bloch de prejarossa",
  "block.minecraft.nether_quartz_ore": "mineral de quarz del nether",
  "block.minecraft.hopper": "tremoeusgia",
  "block.minecraft.chiseled_quartz_block": "bloch de quarz sigillad",
  "block.minecraft.quartz_block": "bloch de quarz",
  "block.minecraft.quartz_bricks": "quadrei de quarz",
  "block.minecraft.quartz_pillar": "pilaster de quarz",
  "block.minecraft.quartz_stairs": "basei de quarz",
  "block.minecraft.activator_rail": "binari pizzador",
  "block.minecraft.dropper": "lassador",
  "block.minecraft.white_terracotta": "terracota bianca",
  "block.minecraft.orange_terracotta": "terracota naranza",
  "block.minecraft.magenta_terracotta": "terracota magenta",
  "block.minecraft.light_blue_terracotta": "terracota bloeu ciar",
  "block.minecraft.yellow_terracotta": "terracota sgialda",
  "block.minecraft.lime_terracotta": "terracota lime",
  "block.minecraft.pink_terracotta": "terracota roeusa",
  "block.minecraft.gray_terracotta": "terracota grisa",
  "block.minecraft.light_gray_terracotta": "terracota grisa ciar",
  "block.minecraft.cyan_terracotta": "terracota celesta",
  "block.minecraft.purple_terracotta": "terracota vioeula",
  "block.minecraft.blue_terracotta": "terracota bloeu",
  "block.minecraft.brown_terracotta": "terracota marrona",
  "block.minecraft.green_terracotta": "terracota verda",
  "block.minecraft.red_terracotta": "terracota rossa",
  "block.minecraft.black_terracotta": "terracota negra",
  "block.minecraft.barrier": "bariera",
  "block.minecraft.iron_trapdoor": "bussera de ferr",
  "block.minecraft.hay_block": "balla de fen",
  "block.minecraft.white_carpet": "tapet bianch",
  "block.minecraft.orange_carpet": "tapet naranz",
  "block.minecraft.magenta_carpet": "tapet magenta",
  "block.minecraft.light_blue_carpet": "tapet bloeu ciar",
  "block.minecraft.yellow_carpet": "tapet sgiald",
  "block.minecraft.lime_carpet": "tapet lime",
  "block.minecraft.pink_carpet": "tapet roeusa",
  "block.minecraft.gray_carpet": "tapet gris",
  "block.minecraft.light_gray_carpet": "tapet gris ciar",
  "block.minecraft.cyan_carpet": "tapet celest",
  "block.minecraft.purple_carpet": "tapet vioeula",
  "block.minecraft.blue_carpet": "tapet bloeu",
  "block.minecraft.brown_carpet": "tapet marron",
  "block.minecraft.green_carpet": "tapet verd",
  "block.minecraft.red_carpet": "tapet ross",
  "block.minecraft.black_carpet": "tapet negher",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloch de carbon",
  "block.minecraft.packed_ice": "giazz compat",
  "block.minecraft.acacia_stairs": "basei de rubinia",
  "block.minecraft.dark_oak_stairs": "basei de rogora",
  "block.minecraft.slime_block": "bloch de slime",
  "block.minecraft.grass_path": "senter d'erba",
  "block.minecraft.sunflower": "girasol",
  "block.minecraft.lilac": "lilà",
  "block.minecraft.rose_bush": "boscal de roeuse",
  "block.minecraft.peony": "peonia",
  "block.minecraft.tall_grass": "erba volta",
  "block.minecraft.large_fern": "files gigant",
  "block.minecraft.white_stained_glass": "veder bianch",
  "block.minecraft.orange_stained_glass": "veder naranz",
  "block.minecraft.magenta_stained_glass": "veder magenta",
  "block.minecraft.light_blue_stained_glass": "veder bloeu ciar",
  "block.minecraft.yellow_stained_glass": "veder sgiald",
  "block.minecraft.lime_stained_glass": "veder lime",
  "block.minecraft.pink_stained_glass": "veder roeusa",
  "block.minecraft.gray_stained_glass": "veder gris",
  "block.minecraft.light_gray_stained_glass": "veder gris ciar",
  "block.minecraft.cyan_stained_glass": "veder celest",
  "block.minecraft.purple_stained_glass": "veder vioeula",
  "block.minecraft.blue_stained_glass": "veder bloeu",
  "block.minecraft.brown_stained_glass": "veder marron",
  "block.minecraft.green_stained_glass": "veder verd",
  "block.minecraft.red_stained_glass": "veder ross",
  "block.minecraft.black_stained_glass": "veder negher",
  "block.minecraft.white_stained_glass_pane": "panell de veder bianch",
  "block.minecraft.orange_stained_glass_pane": "panell de veder naranz",
  "block.minecraft.magenta_stained_glass_pane": "panell de veder magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panell de veder bloeu ciar",
  "block.minecraft.yellow_stained_glass_pane": "panell de veder sgiald",
  "block.minecraft.lime_stained_glass_pane": "panell de veder lime",
  "block.minecraft.pink_stained_glass_pane": "panell de veder roeusa",
  "block.minecraft.gray_stained_glass_pane": "panell de veder gris",
  "block.minecraft.light_gray_stained_glass_pane": "panell de veder gris ciar",
  "block.minecraft.cyan_stained_glass_pane": "panell de veder celest",
  "block.minecraft.purple_stained_glass_pane": "panell de veder vioeula",
  "block.minecraft.blue_stained_glass_pane": "panell de veder bloeu",
  "block.minecraft.brown_stained_glass_pane": "panell de veder marron",
  "block.minecraft.green_stained_glass_pane": "panell de veder verd",
  "block.minecraft.red_stained_glass_pane": "panell de veder ross",
  "block.minecraft.black_stained_glass_pane": "panell de veder negher",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "quadrei de prismarina",
  "block.minecraft.dark_prismarine": "prismarina scura",
  "block.minecraft.prismarine_stairs": "basei de prismarina",
  "block.minecraft.prismarine_brick_stairs": "basei de quadrei de prismarina",
  "block.minecraft.dark_prismarine_stairs": "basei de prismarina scura",
  "block.minecraft.sea_lantern": "lanterna del mar",
  "block.minecraft.red_sandstone": "molera rossa",
  "block.minecraft.chiseled_red_sandstone": "molera rossa sigillada",
  "block.minecraft.cut_red_sandstone": "molera rossa tajada",
  "block.minecraft.red_sandstone_stairs": "basei de molera rossa",
  "block.minecraft.repeating_command_block": "bloch di comand a repetizzion",
  "block.minecraft.chain_command_block": "bloch di comand a cadena",
  "block.minecraft.magma_block": "bloch de magma",
  "block.minecraft.nether_wart_block": "bloch de verruche del nether",
  "block.minecraft.warped_wart_block": "bloch de verruca desformada",
  "block.minecraft.red_nether_bricks": "quadrei ross del nether",
  "block.minecraft.bone_block": "bloch de oss",
  "block.minecraft.structure_void": "voeui de la strutura",
  "block.minecraft.observer": "osservador",
  "block.minecraft.shulker_box": "scatola de shulker",
  "block.minecraft.white_shulker_box": "scatola de shulker bianca",
  "block.minecraft.orange_shulker_box": "scatola de shulker naranza",
  "block.minecraft.magenta_shulker_box": "scatola de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "scatola de shulker bloeu ciar",
  "block.minecraft.yellow_shulker_box": "scatola de shulker sgialda",
  "block.minecraft.lime_shulker_box": "scatola de shulker lime",
  "block.minecraft.pink_shulker_box": "scatola de shulker roeusa",
  "block.minecraft.gray_shulker_box": "scatola de shulker grisa",
  "block.minecraft.light_gray_shulker_box": "scatola de shulker grisa ciar",
  "block.minecraft.cyan_shulker_box": "scatola de shulker celesta",
  "block.minecraft.purple_shulker_box": "scatola de shulker vioeula",
  "block.minecraft.blue_shulker_box": "scatola de shulker bloeu",
  "block.minecraft.brown_shulker_box": "scatola de shulker marrona",
  "block.minecraft.green_shulker_box": "scatola de shulker verda",
  "block.minecraft.red_shulker_box": "scatola de shulker rossa",
  "block.minecraft.black_shulker_box": "scatola de shulker negra",
  "block.minecraft.white_glazed_terracotta": "terracota smaltada bianca",
  "block.minecraft.orange_glazed_terracotta": "terracota smaltada naranza",
  "block.minecraft.magenta_glazed_terracotta": "terracota smaltada magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terracota smaltada bloeu ciar",
  "block.minecraft.yellow_glazed_terracotta": "terracota smaltada sgialda",
  "block.minecraft.lime_glazed_terracotta": "terracota smaltada lime",
  "block.minecraft.pink_glazed_terracotta": "terracota smaltada roeusa",
  "block.minecraft.gray_glazed_terracotta": "terracota smaltada grisa",
  "block.minecraft.light_gray_glazed_terracotta": "terracota smaltada grisa ciar",
  "block.minecraft.cyan_glazed_terracotta": "terracota smaltada celesta",
  "block.minecraft.purple_glazed_terracotta": "terracota smaltada vioeula",
  "block.minecraft.blue_glazed_terracotta": "terracota smaltada bloeu",
  "block.minecraft.brown_glazed_terracotta": "terracota smaltada marrona",
  "block.minecraft.green_glazed_terracotta": "terracota smaltada verda",
  "block.minecraft.red_glazed_terracotta": "terracota smaltada rossa",
  "block.minecraft.black_glazed_terracotta": "terracota smaltada negra",
  "block.minecraft.white_concrete": "ciment bianch",
  "block.minecraft.orange_concrete": "ciment naranz",
  "block.minecraft.magenta_concrete": "ciment magenta",
  "block.minecraft.light_blue_concrete": "ciment bloeu ciar",
  "block.minecraft.yellow_concrete": "ciment sgiald",
  "block.minecraft.lime_concrete": "ciment lime",
  "block.minecraft.pink_concrete": "ciment roeusa",
  "block.minecraft.gray_concrete": "ciment gris",
  "block.minecraft.light_gray_concrete": "ciment gris ciar",
  "block.minecraft.cyan_concrete": "ciment celest",
  "block.minecraft.purple_concrete": "ciment vioeula",
  "block.minecraft.blue_concrete": "ciment bloeu",
  "block.minecraft.brown_concrete": "ciment marron",
  "block.minecraft.green_concrete": "ciment verd",
  "block.minecraft.red_concrete": "ciment ross",
  "block.minecraft.black_concrete": "ciment negher",
  "block.minecraft.white_concrete_powder": "polver de ciment bianca",
  "block.minecraft.orange_concrete_powder": "polver de ciment naranz",
  "block.minecraft.magenta_concrete_powder": "polver de ciment magenta",
  "block.minecraft.light_blue_concrete_powder": "polver de ciment bloeu ciar",
  "block.minecraft.yellow_concrete_powder": "polver de ciment sgialda",
  "block.minecraft.lime_concrete_powder": "polver de ciment lime",
  "block.minecraft.pink_concrete_powder": "polver de ciment roeusa",
  "block.minecraft.gray_concrete_powder": "polver de ciment grisa",
  "block.minecraft.light_gray_concrete_powder": "polver de ciment grisa ciar",
  "block.minecraft.cyan_concrete_powder": "polver de ciment celesta",
  "block.minecraft.purple_concrete_powder": "polver de ciment vioeula",
  "block.minecraft.blue_concrete_powder": "polver de ciment bloeu",
  "block.minecraft.brown_concrete_powder": "polver de ciment marrona",
  "block.minecraft.green_concrete_powder": "polver de ciment verda",
  "block.minecraft.red_concrete_powder": "polver de ciment rossa",
  "block.minecraft.black_concrete_powder": "polver de ciment negra",
  "block.minecraft.turtle_egg": "oeuv de bissa scudellera",
  "block.minecraft.dead_tube_coral_block": "bloch de corall a tubo mort",
  "block.minecraft.dead_brain_coral_block": "bloch de corall a cervell mort",
  "block.minecraft.dead_bubble_coral_block": "bloch de corall a balle mort",
  "block.minecraft.dead_fire_coral_block": "bloch de corall de foeugh mort",
  "block.minecraft.dead_horn_coral_block": "bloch de corall a corna mort",
  "block.minecraft.tube_coral_block": "bloch de corall a tubo",
  "block.minecraft.brain_coral_block": "bloch de corall a cervell",
  "block.minecraft.bubble_coral_block": "bloch de corall a balle",
  "block.minecraft.fire_coral_block": "bloch de corall de foeugh",
  "block.minecraft.horn_coral_block": "bloch de corall a corna",
  "block.minecraft.tube_coral": "corall a tubo",
  "block.minecraft.brain_coral": "corall a cervell",
  "block.minecraft.bubble_coral": "corall a balle",
  "block.minecraft.fire_coral": "corall de foeugh",
  "block.minecraft.horn_coral": "corall a corna",
  "block.minecraft.dead_brain_coral": "corall a cervell mort",
  "block.minecraft.dead_bubble_coral": "corall a balle mort",
  "block.minecraft.dead_fire_coral": "corall de foeugh mort",
  "block.minecraft.dead_horn_coral": "corall a corna mort",
  "block.minecraft.dead_tube_coral": "corall a tubo mort",
  "block.minecraft.tube_coral_fan": "gorgonia a tubo",
  "block.minecraft.brain_coral_fan": "gorgonia a cervell",
  "block.minecraft.bubble_coral_fan": "gorgonia a balle",
  "block.minecraft.fire_coral_fan": "gorgonia de foeugh",
  "block.minecraft.horn_coral_fan": "gorgonia a corna",
  "block.minecraft.dead_tube_coral_fan": "gorgonia a tubo morta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia a cervell morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia a balle morta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de foeugh morta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia a corna morta",
  "block.minecraft.blue_ice": "giazz bloeu",
  "block.minecraft.conduit": "condot",
  "block.minecraft.polished_granite_stairs": "basei de miaroeul soliad",
  "block.minecraft.smooth_red_sandstone_stairs": "basei de molera rossa soliada",
  "block.minecraft.mossy_stone_brick_stairs": "basei de quadrei de preja tepos",
  "block.minecraft.polished_diorite_stairs": "basei de serizz soliad",
  "block.minecraft.mossy_cobblestone_stairs": "basei de rizzoeui tepos",
  "block.minecraft.end_stone_brick_stairs": "basei de quadrei de preja de l'end",
  "block.minecraft.stone_stairs": "basei de preja",
  "block.minecraft.smooth_sandstone_stairs": "basei de molera lissa",
  "block.minecraft.smooth_quartz_stairs": "basei de quarz liss",
  "block.minecraft.granite_stairs": "basei de miaroeul",
  "block.minecraft.andesite_stairs": "basei de andesit",
  "block.minecraft.red_nether_brick_stairs": "basei de quadrei ross del nether",
  "block.minecraft.polished_andesite_stairs": "basei de andesit soliada",
  "block.minecraft.diorite_stairs": "basei de serizz",
  "block.minecraft.polished_granite_slab": "pioda de miaroeul soliad",
  "block.minecraft.smooth_red_sandstone_slab": "pioda de molera rossa lissa",
  "block.minecraft.mossy_stone_brick_slab": "pioda de quadrei de preja tepos",
  "block.minecraft.polished_diorite_slab": "pioda de serizz soliad",
  "block.minecraft.mossy_cobblestone_slab": "pioda de rizzoeui tepos",
  "block.minecraft.end_stone_brick_slab": "pioda de quadrei de preja de l'end",
  "block.minecraft.smooth_sandstone_slab": "pioda de molera lissa",
  "block.minecraft.smooth_quartz_slab": "pioda de quarz liss",
  "block.minecraft.granite_slab": "pioda de miaroeul",
  "block.minecraft.andesite_slab": "pioda de andesit",
  "block.minecraft.red_nether_brick_slab": "pioda de quadrei ross del nether",
  "block.minecraft.polished_andesite_slab": "pioda de andesit soliada",
  "block.minecraft.diorite_slab": "pioda de serizz",
  "block.minecraft.scaffolding": "pontegg",
  "block.minecraft.iron_door": "porta de ferr",
  "block.minecraft.oak_door": "porta de cerr",
  "block.minecraft.spruce_door": "porta de abiezz",
  "block.minecraft.birch_door": "porta de biolla",
  "block.minecraft.jungle_door": "porta de la sgiungla",
  "block.minecraft.acacia_door": "porta de rubinia",
  "block.minecraft.dark_oak_door": "porta de rogora",
  "block.minecraft.crimson_door": "porta cremesa",
  "block.minecraft.warped_door": "porta desformada",
  "block.minecraft.repeater": "repetidor de prejarossa",
  "block.minecraft.comparator": "comparador de prejarossa",
  "block.minecraft.structure_block": "bloch strutura",
  "block.minecraft.jigsaw": "bloch puzzle",
  "item.minecraft.turtle_helmet": "guss de bissa scudellera□□in sul coo:□+2 armadura",
  "item.minecraft.scute": "scheja de bissa scudellera",
  "item.minecraft.iron_shovel": "baira de ferr□□in la man principala:□+3.5 dagn per colp□-3 velocità de atach",
  "item.minecraft.iron_pickaxe": "picozz de ferr□□in la man principala:□+3 dagn per colp□-2.8 velocità de atach",
  "item.minecraft.iron_axe": "segurin de ferr□□in la man principala:□+8 dagn per colp□-3.1 velocità de atach",
  "item.minecraft.flint_and_steel": "spara-foeugh",
  "item.minecraft.apple": "pom",
  "item.minecraft.bow": "arch",
  "item.minecraft.arrow": "flizza",
  "item.minecraft.coal": "carbon",
  "item.minecraft.charcoal": "carbonella",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingot de ferr",
  "item.minecraft.gold_ingot": "lingot d'or",
  "item.minecraft.netherite_ingot": "lingot de netherite",
  "item.minecraft.netherite_scrap": "tochei de netherite",
  "item.minecraft.iron_sword": "spada de ferr□□in la man principala:□+5 dagn per colp□-2.4 velocità de atach",
  "item.minecraft.wooden_sword": "spada de legn□□in la man principala:□+3 dagn per colp□-2.4 velocità de atach",
  "item.minecraft.wooden_shovel": "baira de legn□□in la man principala:□+1.5 dagn per colp□-3 velocità de atach",
  "item.minecraft.wooden_pickaxe": "picozz de legn□□in la man principala:□+1 dagn per colp□-2.8 velocità de atach",
  "item.minecraft.wooden_axe": "segurin de legn□□in la man principala:□+6 dagn per colp□-3.2 velocità de atach",
  "item.minecraft.stone_sword": "spada de preja□□in la man principala:□+4 dagn per colp□-2.4 velocità de atach",
  "item.minecraft.stone_shovel": "baira de preja□□in la man principala:□+2.5 dagn per colp□-3 velocità de atach",
  "item.minecraft.stone_pickaxe": "picozz de preja□□in la man principala:□+2 dagn per colp□-2.8 velocità de atach",
  "item.minecraft.stone_axe": "segurin de preja□□in la man principala:□+8 dagn per colp□-3.2 velocità de atach",
  "item.minecraft.diamond_sword": "spada de diamant□□in la man principala:□+6 dagn per colp□-2.4 velocità de atach",
  "item.minecraft.diamond_shovel": "baira de diamant□□in la man principala:□+4.5 dagn per colp□-3 velocità de atach",
  "item.minecraft.diamond_pickaxe": "picozz de diamant□□in la man principala:□+4 dagn per colp□-2.8 velocità de atach",
  "item.minecraft.diamond_axe": "segurin de diamant□□in la man principala:□+8 dagn per colp□-3 velocità de atach",
  "item.minecraft.stick": "baston",
  "item.minecraft.bowl": "squella",
  "item.minecraft.mushroom_stew": "stracot de fonsg",
  "item.minecraft.golden_sword": "spada d'or□□in la man principala:□+3 dagn per colp□-2.4 velocità de atach",
  "item.minecraft.golden_shovel": "baira d'ora□□in la man principala:□+1.5 dagn per colp□-3 velocità de atach",
  "item.minecraft.golden_pickaxe": "picozz d'or□□in la man principala:□+1 dagn per colp□-2.8 velocità de atach",
  "item.minecraft.golden_axe": "segurin d'or□□in la man principala:□+6 dagn per colp□-3 velocità de atach",
  "item.minecraft.netherite_sword": "spada de netherite□□in la man principala:□+7 dagn per colp□-2.4 velocità de atach",
  "item.minecraft.netherite_shovel": "baira de netherite□□in la man principala:□+5.5 dagn per colp□-3 velocità de atach",
  "item.minecraft.netherite_pickaxe": "picozz de netherite□□in la man principala:□+5 dagn per colp□-2.8 velocità de atach",
  "item.minecraft.netherite_axe": "segurin de netherite□□in la man principala:□+9 dagn per colp□-3 velocità de atach",
  "item.minecraft.string": "fil",
  "item.minecraft.feather": "piuma",
  "item.minecraft.gunpowder": "polver de s'ciop",
  "item.minecraft.wooden_hoe": "zapa de legn□□in la man principala:□-3 velocità de atach",
  "item.minecraft.stone_hoe": "zapa de preja□□in la man principala:□-2 velocità de atach",
  "item.minecraft.iron_hoe": "zapa de ferr□□in la man principala:□-1 velocità de atach",
  "item.minecraft.diamond_hoe": "zapa de diamant□□in la man principala:",
  "item.minecraft.golden_hoe": "zapa d'or□□in la man principala:□-3 velocità de atach",
  "item.minecraft.netherite_hoe": "zapa de netherite□□in la man principala:",
  "item.minecraft.wheat_seeds": "somenza de forment",
  "item.minecraft.wheat": "forment",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "capell de coram□□in sul coo:□+1 armadura",
  "item.minecraft.leather_chestplate": "gipa de coram□□in sul corp:□+3 armadura",
  "item.minecraft.leather_leggings": "braghe de coram□□in sui gambe:□+2 armadura",
  "item.minecraft.leather_boots": "strivai de coram□□in sui pè:□+1 armadura",
  "item.minecraft.chainmail_helmet": "elm de maja□□in sul coo:□+2 armadura",
  "item.minecraft.chainmail_chestplate": "cota de maja□□in sul corp:□+5 armadura",
  "item.minecraft.chainmail_leggings": "gambai de maja□□in sui gambe:□+4 armadura",
  "item.minecraft.chainmail_boots": "strivai de maja□□in sui pè:□+1 armadura",
  "item.minecraft.iron_helmet": "elm de ferr□□in sul coo:□+2 armadura",
  "item.minecraft.iron_chestplate": "corazza de ferr□□in sul corp:□+6 armadura",
  "item.minecraft.iron_leggings": "gambai de ferr□□in sui gambe:□+5 armadura",
  "item.minecraft.iron_boots": "strivai de ferr□□in sui pè:□+2 armadura",
  "item.minecraft.diamond_helmet": "elm de diamant□□in sul coo:□+3 armadura□+2 durezza de l'armadura",
  "item.minecraft.diamond_chestplate": "corazza de diamant□□in sul corp:□+8 armadura□+2 durezza de l'armadura",
  "item.minecraft.diamond_leggings": "gambai de diamant□□in sui gambe:□+6 armadura□+2 durezza de l'armadura",
  "item.minecraft.diamond_boots": "strivai de diamant□□in sui pè:□+3 armadura□+2 durezza de l'armadura",
  "item.minecraft.golden_helmet": "elm d'or□□in sul coo:□+2 armadura",
  "item.minecraft.golden_chestplate": "corazza d'ora□□in sul corp:□+5 armadura",
  "item.minecraft.golden_leggings": "gambai d'or□□in sui gambe:□+3 armadura",
  "item.minecraft.golden_boots": "strivai d'or□□in sui pè:□+1 armadura",
  "item.minecraft.netherite_helmet": "elm de netherite□□in sul coo:□+3 armadura□+3 durezza de l'armadura□+1 resistenza al contra-colp",
  "item.minecraft.netherite_chestplate": "corazza de netherite□□in sul corp:□+8 armadura□+3 durezza de l'armadura□+1 resistenza al contra-colp",
  "item.minecraft.netherite_leggings": "gambai de netherite□□in sui gambe:□+6 armadura□+3 durezza de l'armadura□+1 resistenza al contra-colp",
  "item.minecraft.netherite_boots": "strivai de netherite□□in sui pè:□+3 armadura□+3 durezza de l'armadura□+1 resistenza al contra-colp",
  "item.minecraft.flint": "serizz",
  "item.minecraft.porkchop": "brassoeula de porcell cruda",
  "item.minecraft.cooked_porkchop": "brassoeula de porcell cota",
  "item.minecraft.painting": "quader",
  "item.minecraft.golden_apple": "pom d'or",
  "item.minecraft.enchanted_golden_apple": "pom d'or instriad",
  "block.minecraft.oak_sign": "cartell de cerr",
  "block.minecraft.spruce_sign": "cartell de abiezz",
  "block.minecraft.birch_sign": "cartell de biolla",
  "block.minecraft.jungle_sign": "cartell de la sgiungla",
  "block.minecraft.acacia_sign": "cartell de rubinia",
  "block.minecraft.dark_oak_sign": "cartell de rogora",
  "block.minecraft.crimson_sign": "cartell cremes",
  "block.minecraft.warped_sign": "cartell desformad",
  "item.minecraft.bucket": "sidell",
  "item.minecraft.water_bucket": "sidell d'aqua",
  "item.minecraft.lava_bucket": "sidell de lava",
  "item.minecraft.minecart": "carrell de minera",
  "item.minecraft.saddle": "sella",
  "item.minecraft.redstone": "polver de prejarossa",
  "item.minecraft.snowball": "balla de fioca",
  "item.minecraft.oak_boat": "barca de cerr",
  "item.minecraft.leather": "coram",
  "item.minecraft.milk_bucket": "sidell de lacc",
  "item.minecraft.pufferfish_bucket": "sidell con pess-balla",
  "item.minecraft.salmon_bucket": "sidell con salmon",
  "item.minecraft.cod_bucket": "sidell con merluzz",
  "item.minecraft.tropical_fish_bucket": "sidell de pess tropegal",
  "item.minecraft.brick": "quadrell",
  "item.minecraft.clay_ball": "balla de argilla",
  "block.minecraft.dried_kelp_block": "bloch de alghe seche",
  "item.minecraft.paper": "carta",
  "item.minecraft.book": "liber",
  "item.minecraft.slime_ball": "balla de slime",
  "item.minecraft.chest_minecart": "carrell de minera con cesta",
  "item.minecraft.furnace_minecart": "carrell de minera con prestin",
  "item.minecraft.egg": "oeuv",
  "item.minecraft.compass": "bussola",
  "item.minecraft.fishing_rod": "canna de pesca",
  "item.minecraft.clock": "orelogg",
  "item.minecraft.glowstone_dust": "polver de preja lusenta",
  "item.minecraft.cod": "merluzz crud",
  "item.minecraft.salmon": "salmon crud",
  "item.minecraft.tropical_fish": "pess tropegal",
  "item.minecraft.pufferfish": "pess-balla",
  "item.minecraft.cooked_cod": "merluzz cot",
  "item.minecraft.cooked_salmon": "salmon cot",
  "item.minecraft.ink_sac": "saca de incioster",
  "item.minecraft.red_dye": "colorant ross",
  "item.minecraft.green_dye": "colorant verd",
  "item.minecraft.cocoa_beans": "fave de cacao",
  "item.minecraft.lapis_lazuli": "lapislazzer",
  "item.minecraft.purple_dye": "colorant vioeula",
  "item.minecraft.cyan_dye": "colorant celest",
  "item.minecraft.light_gray_dye": "colorant gris ciar",
  "item.minecraft.gray_dye": "colorant gris",
  "item.minecraft.pink_dye": "colorant roeusa",
  "item.minecraft.lime_dye": "colorant lime",
  "item.minecraft.yellow_dye": "colorant sgiald",
  "item.minecraft.light_blue_dye": "colorant bloeu ciar",
  "item.minecraft.magenta_dye": "colorant magenta",
  "item.minecraft.orange_dye": "colorant naranz",
  "item.minecraft.bone_meal": "polver de oss",
  "item.minecraft.blue_dye": "colorant bloeu",
  "item.minecraft.brown_dye": "colorant marron",
  "item.minecraft.black_dye": "colorant negher",
  "item.minecraft.white_dye": "colorant bianch",
  "item.minecraft.bone": "oss",
  "item.minecraft.sugar": "zucher",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "lecc bianch",
  "block.minecraft.orange_bed": "lecc naranz",
  "block.minecraft.magenta_bed": "lecc magenta",
  "block.minecraft.light_blue_bed": "lecc bloeu ciar",
  "block.minecraft.yellow_bed": "lecc sgiald",
  "block.minecraft.lime_bed": "lecc lime",
  "block.minecraft.pink_bed": "lecc roeusa",
  "block.minecraft.gray_bed": "lecc gris",
  "block.minecraft.light_gray_bed": "lecc gris ciar",
  "block.minecraft.cyan_bed": "lecc celest",
  "block.minecraft.purple_bed": "lecc vioeula",
  "block.minecraft.blue_bed": "lecc bloeu",
  "block.minecraft.brown_bed": "lecc marron",
  "block.minecraft.green_bed": "lecc verd",
  "block.minecraft.red_bed": "lecc ross",
  "block.minecraft.black_bed": "lecc negher",
  "item.minecraft.cookie": "biscot",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "s'cesora",
  "item.minecraft.melon_slice": "feta de inguria",
  "item.minecraft.dried_kelp": "alga seca",
  "item.minecraft.pumpkin_seeds": "somenza de zuca",
  "item.minecraft.melon_seeds": "somenza de inguria",
  "item.minecraft.beef": "manz crud",
  "item.minecraft.cooked_beef": "bisteca",
  "item.minecraft.chicken": "pollaster crud",
  "item.minecraft.cooked_chicken": "pollaster cot",
  "item.minecraft.rotten_flesh": "carna marscia",
  "item.minecraft.ender_pearl": "perla de l'ender",
  "item.minecraft.blaze_rod": "verga del blaze",
  "item.minecraft.ghast_tear": "lagrima de ghast",
  "item.minecraft.gold_nugget": "pepita d'ora",
  "item.minecraft.nether_wart": "verruche del nether",
  "item.minecraft.potion": "pozzion che se poeu mìa fà su□nissun efet",
  "item.minecraft.glass_bottle": "botilia de veder",
  "item.minecraft.spider_eye": "oeugg de ragn",
  "item.minecraft.fermented_spider_eye": "oeugg de ragn surbuid",
  "item.minecraft.blaze_powder": "polver de blaze",
  "item.minecraft.magma_cream": "crema de magma",
  "block.minecraft.brewing_stand": "destillador",
  "block.minecraft.cauldron": "calderon",
  "item.minecraft.ender_eye": "oeugg de l'ender",
  "item.minecraft.glistering_melon_slice": "feta de inguria lusenta",
  "item.minecraft.bat_spawn_egg": "oeuv de tegnoeula",
  "item.minecraft.bee_spawn_egg": "oeuv de ava",
  "item.minecraft.blaze_spawn_egg": "oeuv de blaze",
  "item.minecraft.cat_spawn_egg": "oeuv de gat",
  "item.minecraft.cave_spider_spawn_egg": "oeuv de ragn di grote",
  "item.minecraft.chicken_spawn_egg": "oeuv de pollaster",
  "item.minecraft.cod_spawn_egg": "oeuv de merluzz",
  "item.minecraft.cow_spawn_egg": "oeuv de vaca",
  "item.minecraft.creeper_spawn_egg": "oeuv de creeper",
  "item.minecraft.dolphin_spawn_egg": "oeuv de delfin",
  "item.minecraft.donkey_spawn_egg": "oeuv de asen",
  "item.minecraft.drowned_spawn_egg": "oeuv de negad",
  "item.minecraft.elder_guardian_spawn_egg": "oeuv de guardian antigh",
  "item.minecraft.enderman_spawn_egg": "oeuv de enderman",
  "item.minecraft.endermite_spawn_egg": "oeuv de endermite",
  "item.minecraft.evoker_spawn_egg": "oeuv de evocador",
  "item.minecraft.fox_spawn_egg": "oeuv de volp",
  "item.minecraft.ghast_spawn_egg": "oeuv de ghast",
  "item.minecraft.guardian_spawn_egg": "oeuv de guardian",
  "item.minecraft.hoglin_spawn_egg": "oeuv de hoglin",
  "item.minecraft.horse_spawn_egg": "oeuv de cavall",
  "item.minecraft.husk_spawn_egg": "oeuv de zombie del desert",
  "item.minecraft.llama_spawn_egg": "oeuv de lama",
  "item.minecraft.magma_cube_spawn_egg": "oeuv de cub de magma",
  "item.minecraft.mooshroom_spawn_egg": "oeuv de vaca-fonsg",
  "item.minecraft.mule_spawn_egg": "oeuv de mull",
  "item.minecraft.ocelot_spawn_egg": "oeuv de gatopard",
  "item.minecraft.panda_spawn_egg": "oeuv de panda",
  "item.minecraft.parrot_spawn_egg": "oeuv de papagall",
  "item.minecraft.phantom_spawn_egg": "oeuv de fantasma",
  "item.minecraft.pig_spawn_egg": "oeuv de porscell",
  "item.minecraft.piglin_spawn_egg": "oeuv de piglin",
  "item.minecraft.pillager_spawn_egg": "oeuv de lader",
  "item.minecraft.polar_bear_spawn_egg": "oeuv de ors polar",
  "item.minecraft.pufferfish_spawn_egg": "oeuv de pess-balla",
  "item.minecraft.rabbit_spawn_egg": "oeuv de conili",
  "item.minecraft.ravager_spawn_egg": "oeuv de s'cepa-tut",
  "item.minecraft.salmon_spawn_egg": "oeuv de salmon",
  "item.minecraft.sheep_spawn_egg": "oeuv de pegora",
  "item.minecraft.shulker_spawn_egg": "oeuv de shulker",
  "item.minecraft.silverfish_spawn_egg": "oeuv de pess d'arsgent",
  "item.minecraft.skeleton_spawn_egg": "oeuv de schelter",
  "item.minecraft.skeleton_horse_spawn_egg": "oeuv de cavall schelter",
  "item.minecraft.slime_spawn_egg": "oeuv de slime",
  "item.minecraft.spider_spawn_egg": "oeuv de ragn",
  "item.minecraft.squid_spawn_egg": "oeuv de calamar",
  "item.minecraft.stray_spawn_egg": "oeuv de schelter di nev",
  "item.minecraft.strider_spawn_egg": "oeuv de strider",
  "item.minecraft.trader_llama_spawn_egg": "oeuv de lama ramingh",
  "item.minecraft.tropical_fish_spawn_egg": "oeuv de pess tropegal",
  "item.minecraft.turtle_spawn_egg": "oeuv de bissa scudellera",
  "item.minecraft.vex_spawn_egg": "oeuv de spirit",
  "item.minecraft.villager_spawn_egg": "oeuv de paisan",
  "item.minecraft.vindicator_spawn_egg": "oeuv de vendegador",
  "item.minecraft.wandering_trader_spawn_egg": "oeuv de mercant ramingh",
  "item.minecraft.witch_spawn_egg": "oeuv de stria",
  "item.minecraft.wither_skeleton_spawn_egg": "oeuv de schelter wither",
  "item.minecraft.wolf_spawn_egg": "oeuv de lov",
  "item.minecraft.zoglin_spawn_egg": "oeuv de zoglin",
  "item.minecraft.zombie_spawn_egg": "oeuv de zombie",
  "item.minecraft.zombie_horse_spawn_egg": "oeuv de cavall zombie",
  "item.minecraft.zombie_villager_spawn_egg": "oeuv de paisan zombie",
  "item.minecraft.zombified_piglin_spawn_egg": "oeuv de piglin zombifegad",
  "item.minecraft.experience_bottle": "botilia d'esperienza",
  "item.minecraft.fire_charge": "carga de foeugh",
  "item.minecraft.writable_book": "liber e pena",
  "item.minecraft.written_book": "liber scrit",
  "item.minecraft.emerald": "smerald",
  "item.minecraft.item_frame": "cornis",
  "block.minecraft.flower_pot": "vas de fior",
  "item.minecraft.carrot": "carotola",
  "item.minecraft.potato": "pom de terra",
  "item.minecraft.baked_potato": "pom de terra cot",
  "item.minecraft.poisonous_potato": "pom de terra toeussega",
  "item.minecraft.map": "mapa voeuda",
  "item.minecraft.golden_carrot": "carotola d'ora",
  "block.minecraft.skeleton_skull": "coo de schelter",
  "block.minecraft.wither_skeleton_skull": "coo de schelter wither",
  "block.minecraft.player_head": "coo de sgiugador",
  "block.minecraft.zombie_head": "coo de zombie",
  "block.minecraft.creeper_head": "coo de creeper",
  "block.minecraft.dragon_head": "coo de dragon",
  "item.minecraft.carrot_on_a_stick": "baston e carotola",
  "item.minecraft.warped_fungus_on_a_stick": "baston con fonsg desformad",
  "item.minecraft.nether_star": "stella del nether",
  "item.minecraft.pumpkin_pie": "torta de zuca",
  "item.minecraft.firework_rocket": "razz pirotecnegh",
  "item.minecraft.firework_star": "stella pirotecnega",
  "item.minecraft.enchanted_book": "liber instriad",
  "item.minecraft.nether_brick": "quadrell del nether",
  "item.minecraft.quartz": "quarz del nether",
  "item.minecraft.tnt_minecart": "carrell de minera con dimanit",
  "item.minecraft.hopper_minecart": "carrell de minera con tramoeugia",
  "item.minecraft.prismarine_shard": "scheja de prismarina",
  "item.minecraft.prismarine_crystals": "cristai de prismarina",
  "item.minecraft.rabbit": "conili crud",
  "item.minecraft.cooked_rabbit": "conili cot",
  "item.minecraft.rabbit_stew": "stuvad de conili",
  "item.minecraft.rabbit_foot": "sciampa de conili",
  "item.minecraft.rabbit_hide": "pell de conili",
  "item.minecraft.armor_stand": "suport per armadure",
  "item.minecraft.iron_horse_armor": "armadura de ferr per cavall",
  "item.minecraft.golden_horse_armor": "armadura d'ora per cavall",
  "item.minecraft.diamond_horse_armor": "armadura de diamant per cavall",
  "item.minecraft.leather_horse_armor": "armadura de coram per cavall",
  "item.minecraft.lead": "sguinzal",
  "item.minecraft.name_tag": "eticheta",
  "item.minecraft.command_block_minecart": "carrell de minera con bloch di comand",
  "item.minecraft.mutton": "bar crud",
  "item.minecraft.cooked_mutton": "bar cot",
  "block.minecraft.white_banner": "bandera bianca",
  "block.minecraft.orange_banner": "bandera naranza",
  "block.minecraft.magenta_banner": "bandera magenta",
  "block.minecraft.light_blue_banner": "bandera bloeu ciar",
  "block.minecraft.yellow_banner": "bandera sgialda",
  "block.minecraft.lime_banner": "bandera lime",
  "block.minecraft.pink_banner": "bandera roeusa",
  "block.minecraft.gray_banner": "bandera grisa",
  "block.minecraft.light_gray_banner": "bandera grisa ciar",
  "block.minecraft.cyan_banner": "bandera celesta",
  "block.minecraft.purple_banner": "bandera vioeula",
  "block.minecraft.blue_banner": "bandera bloeu",
  "block.minecraft.brown_banner": "bandera marrona",
  "block.minecraft.green_banner": "bandera verda",
  "block.minecraft.red_banner": "bandera rossa",
  "block.minecraft.black_banner": "bandera negra",
  "item.minecraft.end_crystal": "cristall de l'end",
  "item.minecraft.chorus_fruit": "frut de chorus",
  "item.minecraft.popped_chorus_fruit": "frut de chorus s'ciopad",
  "item.minecraft.beetroot": "biedrava",
  "item.minecraft.beetroot_seeds": "somenza de biedrave",
  "item.minecraft.beetroot_soup": "supa de biedrave",
  "item.minecraft.dragon_breath": "bofada de dragon",
  "item.minecraft.splash_potion": "pozzion de tirà che se poeu mìa fà su□nissun efet",
  "item.minecraft.spectral_arrow": "flizza spetral",
  "item.minecraft.tipped_arrow": "flizza imbibida che se poeu mìa fà su□nissun efet",
  "item.minecraft.lingering_potion": "pozzion persistenta minga fabricabil□nissun efet",
  "item.minecraft.shield": "scud",
  "item.minecraft.elytra": "eliter",
  "item.minecraft.spruce_boat": "barca de abiezz",
  "item.minecraft.birch_boat": "barca de biolla",
  "item.minecraft.jungle_boat": "barca de la sgiungla",
  "item.minecraft.acacia_boat": "barca de rubinia",
  "item.minecraft.dark_oak_boat": "barca de rogora",
  "item.minecraft.totem_of_undying": "totem de l'imortalità",
  "item.minecraft.shulker_shell": "guss de shulker",
  "item.minecraft.iron_nugget": "pepita de ferr",
  "item.minecraft.knowledge_book": "liber de la cognossenza",
  "item.minecraft.debug_stick": "baston de debug",
  "item.minecraft.music_disc_13": "disch de musega□c418 - 13",
  "item.minecraft.music_disc_cat": "disch de musega□c418 - cat",
  "item.minecraft.music_disc_blocks": "disch de musega□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disch de musega□c418 - chirp",
  "item.minecraft.music_disc_far": "disch de musega□c418 - far",
  "item.minecraft.music_disc_mall": "disch de musega□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disch de musega□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disch de musega□c418 - stal",
  "item.minecraft.music_disc_strad": "disch de musega□c418 - strad",
  "item.minecraft.music_disc_ward": "disch de musega□c418 - ward",
  "item.minecraft.music_disc_11": "disch de musega□c418 - 11",
  "item.minecraft.music_disc_wait": "disch de musega□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disch de musega□lena raine - pigstep",
  "item.minecraft.trident": "trident□□in la man principala:□+8 dagn per colp□-2.9 velocità de atach",
  "item.minecraft.phantom_membrane": "membrana de fantasma",
  "item.minecraft.nautilus_shell": "guss de nautilus",
  "item.minecraft.heart_of_the_sea": "coeur del mar",
  "item.minecraft.crossbow": "balestra",
  "item.minecraft.suspicious_stew": "supa sospeta",
  "block.minecraft.loom": "telar",
  "item.minecraft.flower_banner_pattern": "motiv de la bandera□fior",
  "item.minecraft.creeper_banner_pattern": "motiv de la bandera□faza de creeper",
  "item.minecraft.skull_banner_pattern": "motiv de la bandera□crani",
  "item.minecraft.mojang_banner_pattern": "motiv de la bandera□loeugh",
  "item.minecraft.globe_banner_pattern": "motiv de la bandera□pianeta",
  "item.minecraft.piglin_banner_pattern": "motiv de la bandera□grugn",
  "block.minecraft.composter": "compostera",
  "block.minecraft.barrel": "baril",
  "block.minecraft.smoker": "afumegador",
  "block.minecraft.blast_furnace": "volt-forn",
  "block.minecraft.cartography_table": "banch de cartografia",
  "block.minecraft.fletching_table": "banch di flizze",
  "block.minecraft.grindstone": "moeula",
  "block.minecraft.lectern": "letorin",
  "block.minecraft.smithing_table": "tavol del ferrer",
  "block.minecraft.stonecutter": "taja-preje",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "lanterna",
  "block.minecraft.soul_lantern": "lanterna di anime",
  "item.minecraft.sweet_berries": "frut dolz",
  "block.minecraft.campfire": "falò",
  "block.minecraft.soul_campfire": "falò de l'anima",
  "block.minecraft.shroomlight": "sberlus-fonsg",
  "item.minecraft.honeycomb": "beden",
  "block.minecraft.bee_nest": "bisoeul",
  "block.minecraft.beehive": "avigg",
  "item.minecraft.honey_bottle": "botilia de mel",
  "block.minecraft.honey_block": "bloch de mel",
  "block.minecraft.honeycomb_block": "bloch de beden",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "bloch de netherite",
  "block.minecraft.ancient_debris": "rest antigh",
  "block.minecraft.target": "bersai",
  "block.minecraft.crying_obsidian": "ossidiana caragnenta",
  "block.minecraft.blackstone": "prejanegra",
  "block.minecraft.blackstone_slab": "pioda de prejanegra",
  "block.minecraft.blackstone_stairs": "basei de prejanegra",
  "block.minecraft.gilded_blackstone": "prejanegra d'ora",
  "block.minecraft.polished_blackstone": "prejanegra soliada",
  "block.minecraft.polished_blackstone_slab": "pioda de prejanegra soliada",
  "block.minecraft.polished_blackstone_stairs": "basei de prejanegra soliada",
  "block.minecraft.chiseled_polished_blackstone": "prejanegra soliada sigillada",
  "block.minecraft.polished_blackstone_bricks": "quadrei de prejanegra soliada",
  "block.minecraft.polished_blackstone_brick_slab": "pioda de quadrei de prejanegra soliada",
  "block.minecraft.polished_blackstone_brick_stairs": "basei de quadrei de prejanegra soliada",
  "block.minecraft.cracked_polished_blackstone_bricks": "quadrei de prejanegra soliada crep",
  "block.minecraft.respawn_anchor": "ancora de la renassida",
}
export const lmo = items; 
